import { render } from "./PersonAddress.vue?vue&type=template&id=8b15afca&scoped=true"
import script from "./PersonAddress.vue?vue&type=script&lang=js"
export * from "./PersonAddress.vue?vue&type=script&lang=js"

import "./PersonAddress.vue?vue&type=style&index=0&id=8b15afca&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b15afca"]])

export default __exports__